module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Thin.woff
// module id = 261
// module chunks = 0